"use client";

import { sendGTMEvent } from "@next/third-parties/google";

import type { ProductDataLayerType } from "./types";
import { GTagEvents } from "./types";

type RemoveFromCartProps = {
  currency: string;
  value: number;
  item: ProductDataLayerType;
};

export const removeFromCartEvent = ({
  item,
  value,
  currency,
}: RemoveFromCartProps) => {
  console.log("removeFromCartEvent", item, value, currency);

  sendGTMEvent({
    event: GTagEvents.REMOVE_FROM_CART,
    currency,
    value,
    items: [item],
  });
};
